import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.297 9.456A8.808 8.808 0 0 1 10.952 8.2a1.273 1.273 0 0 0-1.48.208 6.48 6.48 0 0 0-.859.978l-.087.115c-.035.045-.06.07-.065.08a.586.586 0 0 1-.125-.049A8.049 8.049 0 0 1 4.828 6.33c-.112-.188-.228-.38-.273-.482.066-.097.227-.277.349-.415a2.116 2.116 0 0 0 .42-2.516A9.757 9.757 0 0 1 4.73 1.26 1.576 1.576 0 0 0 3.05.006 2.354 2.354 0 0 0 1.14.815 4.402 4.402 0 0 0 .385 5.57c1.86 4.402 4.901 7.195 9.036 8.301a3.7 3.7 0 0 0 .958.129 4.078 4.078 0 0 0 2.786-1.205 2.904 2.904 0 0 0 .813-2.393 1.092 1.092 0 0 0-.681-.946Zm-.998 2.408a2.594 2.594 0 0 1-2.55.779c-3.788-1.014-6.469-3.49-8.193-7.57a3.108 3.108 0 0 1 .552-3.435 1.075 1.075 0 0 1 .943-.36c.323 0 .37.034.456.334.169.645.397 1.273.682 1.877.178.353.19.62-.235 1.097-.859.965-.887 1.279-.197 2.43a9.383 9.383 0 0 0 4.025 3.663 1.305 1.305 0 0 0 1.752-.402l.09-.118c.203-.286.432-.551.685-.793a.259.259 0 0 1 .048-.028c.726.523 1.518.947 2.356 1.261a1.581 1.581 0 0 1-.414 1.264Z",
      fill: "#000"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "phone"}) } }